import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import BanquetNavbar from "../components/BanquetNavbar";

const TimelinePage = () => {
  const { t } = useTranslation();
  const [expandedEvent, setExpandedEvent] = useState(null);

  const events = [
    { 
      title: t('sections.timeline.events.ceremony'),
      time: '',
      icon: '⛪',
      description: t('sections.timeline.description.ceremony')
    },
    { 
      title: t('sections.timeline.events.cocktail'),
      time: '',
      icon: '🥂',
      description: t('sections.timeline.description.cocktail')
    },
    { 
      title: t('sections.timeline.events.dinner'),
      time: '',
      icon: '🍽️',
      description: t('sections.timeline.description.dinner')
    },
    { 
      title: t('sections.timeline.events.dance'),
      time: '',
      icon: '🎉',
      description: t('sections.timeline.description.dance')
    },
  ];

  const toggleEvent = (index) => {
    setExpandedEvent(expandedEvent === index ? null : index);
  };
  
  return (
    <div className="flex-1 flex flex-col">
      <div className="flex-none">
        <BanquetNavbar />
      </div>
      <div className="flex-1 flex items-start md:items-center justify-center overflow-y-auto py-4">
        <div className="w-full max-w-6xl px-4 my-auto">
          <div className="bg-white rounded-lg shadow-xl p-4 md:p-6">
            <h2 className="text-2xl font-bold text-beast-brown-800 mb-8 text-center">
              {t('sections.timeline.title')}
            </h2>
            <div className="relative">
              <div className="w-full flex items-center justify-center">
                <div className="relative w-full">
                  {/* Vista móvil */}
                  <div className="md:hidden space-y-6">
                    {events.map((event, index) => (
                      <div key={index} className="w-full">
                        <button 
                          onClick={() => toggleEvent(index)}
                          className="w-full flex items-center gap-4 p-3 rounded-lg bg-castle-cream-100 hover:bg-royal-gold-100 transition-colors"
                        >
                          <div className="w-12 h-12 bg-belle-blue-600 rounded-full flex items-center justify-center shadow-lg flex-shrink-0">
                            <span className="text-xl text-white">{event.icon}</span>
                          </div>
                          <div className="flex-1 text-left">
                            <p className="text-base font-semibold text-beast-brown-800">
                              {event.time}  {event.title}
                            </p>
                          </div>
                          <div className="flex-shrink-0">
                            <svg 
                              className={`w-6 h-6 transform transition-transform ${expandedEvent === index ? 'rotate-180' : ''}`} 
                              fill="none" 
                              stroke="currentColor" 
                              viewBox="0 0 24 24"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </button>
                        {expandedEvent === index && (
                          <div className="mt-2 p-4 bg-white rounded-lg border border-royal-gold-200">
                            <p className="text-base text-beast-brown-700">
                              {event.description}
                            </p>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Vista desktop */}
                  <div className="hidden md:grid grid-cols-4 gap-4">
                    {events.map((event, index) => (
                      <div key={index} className="flex flex-col items-center relative z-10">
                        <div className="w-12 h-12 bg-belle-blue-600 rounded-full flex items-center justify-center shadow-lg">
                          <span className="text-xl text-white">{event.icon}</span>
                        </div>
                        <p className="text-sm font-semibold text-beast-brown-800 mt-3 text-center w-full px-4">
                          {event.time}  {event.title}
                        </p>
                        <div className="mt-3 bg-castle-cream-100 text-beast-brown-700 px-4 py-3 rounded-lg w-full h-32">
                          <p className="text-sm text-center line-clamp-6">
                            {event.description}
                          </p>
                        </div>
                      </div>
                    ))}
                    <div className="absolute top-6 left-0 w-full h-1 bg-belle-blue-600 -z-0" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelinePage;